import { LOGGED_OUT } from 'actions/types';
import { CREDIT_SCORE_GET_HISTORY_FAILURE, CREDIT_SCORE_GET_HISTORY_REQUEST, CREDIT_SCORE_GET_HISTORY_SUCCESS, CREDIT_SCORE_RESET_DATA, } from '../actions/types';
const initialState = {
    entries: [],
    isFetching: false,
};
const creditScoreHistoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGGED_OUT:
        case CREDIT_SCORE_RESET_DATA:
            return initialState;
        case CREDIT_SCORE_GET_HISTORY_REQUEST:
            return { ...state, isFetching: true };
        case CREDIT_SCORE_GET_HISTORY_SUCCESS:
            return {
                ...state,
                entries: action.payload.history,
                isFetching: false,
            };
        case CREDIT_SCORE_GET_HISTORY_FAILURE:
            return { ...state, isFetching: false };
        default:
            return state;
    }
};
export default creditScoreHistoryReducer;
